import React from "react";
import { getErrorCopy } from "./errorCodes";
import "./ErrorScreen.css";

/**
 * TIER 4: Full-page error.
 *
 * Use when the entire surface can't render — primary fetch failed, page
 * crashed in render, or user landed on a bad URL. Shows the Chariot mascot,
 * a status pill, friendly title + message, and up to two action buttons.
 *
 * For section-level failures (one panel can't load but rest of page works),
 * use <InlineError /> instead.
 *
 * Props:
 *   code      — number (400/404/500/...) OR string ("crash"/"offline"/"default")
 *   title     — override the default title from errorCodes
 *   message   — override the default message
 *   primary   — { label, onClick }   right-side button
 *   secondary — { label, onClick }   left-side button
 *   showCode  — show the small status pill (default: true)
 */
const ErrorScreen = ({
  code,
  title,
  message,
  primary,
  secondary,
  showCode = true,
}) => {
  const defaults = getErrorCopy(code);
  return (
    <div className="error-screen">
      <div className="error-screen-card">
        <img
          src="/images/Branding/Mascot/Chariot_Mascot_P1_FullColor_011326.png"
          alt="Chariot"
          className="error-screen-mascot"
        />

        {showCode && (
          <div className="error-screen-code">
            {typeof code === "number" ? `Error ${code}` : defaults.label}
          </div>
        )}

        <h1 className="error-screen-title">{title || defaults.title}</h1>
        <p className="error-screen-message">{message || defaults.message}</p>

        {(primary || secondary) && (
          <div className="error-screen-actions">
            {secondary && (
              <button
                type="button"
                className="error-screen-btn error-screen-btn-secondary"
                onClick={secondary.onClick}
              >
                {secondary.label}
              </button>
            )}
            {primary && (
              <button
                type="button"
                className="error-screen-btn error-screen-btn-primary"
                onClick={primary.onClick}
              >
                {primary.label}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(ErrorScreen);
